module.exports = __webpack_public_path__ + "bj.aa6d71d3.svg";